import React, { useState, useEffect } from 'react';
import { Modal, Select, Button, message, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { FileExcelOutlined } from '@ant-design/icons';
import { start_loading, end_loading } from 'src/core/actions/loader';
import axios from 'src/core/utils/axios';

const FileDownload = require('js-file-download');

const ExcelExportModal = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [yearType, setYearType] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileOptions, setFileOptions] = useState([]);

  const year_type = { 1: 'Эхний үлдэгдэл', 2: 'Тайлант жил' };

  const file_list = {
    1: {
      1: 'Авлагын товчоо',
      2: 'Гүйлгээ баланс',
      3: 'Өглөгийн товчоо',
      4: 'Үндсэн хөрөнгийн өртгийн өөрчлөлт',
      5: 'Үндсэн хөрөнгийн товчоо(хөрөнгөөр)',
      6: 'Бусад нэмэлт мэдээлэл',
    },
    2: {
      1: 'Авлага, өглөгийн баримтын жагсаалт',
      2: 'Гүйлгээний жагсаалт',
      3: 'Үндсэн хөрөнгийн баримтын жагсаалт',
      4: 'Үндсэн хөрөнгийн өртгийн өөрчлөлт',
      5: 'Бусад нэмэлт мэдээлэл',
    },
  };

  const fileMapping = {
    1: {
      // Эхний үлдэгдэл
      1: 'Эхний үлдэгдэл-Авлагын товчоо.xlsx',
      2: 'Эхний үлдэгдэл-Гүйлгээ баланс.xlsx',
      3: 'Эхний үлдэгдэл-Өглөгийн товчоо.xlsx',
      4: 'Эхний үлдэгдэл-Үндсэн хөрөнгийн өртгийн өөрчлөлт.xlsx',
      5: 'Эхний үлдэгдэл-Үндсэн хөрөнгийн товчоо(хөрөнгөөр).xlsx',
      6: 'Эхний үлдэгдэл-Бусад нэмэлт мэдээлэл.xlsx',
    },
    2: {
      // Тайлант жил
      1: 'Тайлант жил-Авлага, өглөгийн баримтын жагсаалт.xlsx',
      2: 'Тайлант жил-Гүйлгээний жагсаалт.xlsx',
      3: 'Тайлант жил-Үндсэн хөрөнгийн баримтын жагсаалт.xlsx',
      4: 'Тайлант жил-Үндсэн хөрөнгийн өртгийн өөрчлөлт.xlsx',
      5: 'Тайлант жил-Бүсэд дэмжлэг мэдээлэл.xlsx',
    },
  };

  useEffect(() => {
    if (yearType) {
      const options = Object.entries(file_list[yearType]).map(
        ([key, value]) => ({
          value: key,
          label: value,
        })
      );
      setFileOptions(options);
      setFileType(null);
    }
  }, [yearType]);

  const handleDownload = async () => {
    if (!yearType || !fileType) {
      message.error('Бүх талбарыг сонгоно уу');
      return;
    }

    setLoading(true);
    dispatch(start_loading({}));

    try {
      const fileName = fileMapping[yearType]?.[fileType];
      if (!fileName) {
        throw new Error('Invalid file type requested');
      }

      await axios.get(
        'storage',
        '/get_file',
        {}, // Empty params
        {
          // Headers
          year_type: yearType,
          file_type: fileType,
        },
        (event) => {
          FileDownload(event, fileName);
          setIsModalOpen(false);
        }
      );
    } catch (error) {
      message.error('Файл татахад алдаа гарлаа');
    } finally {
      setLoading(false);
      dispatch(end_loading({}));
    }
  };

  return (
    <>
      <Tooltip placement="bottomLeft" title="Эксел импорт" color=" #2c3e50">
        <Button
          type="text"
          onClick={() => setIsModalOpen(true)}
          icon={
            <FileExcelOutlined
              className="header-guidebook-download"
              FileExcelOutlined
            />
          }
        />
      </Tooltip>
      <Modal
        title="Эксел импорт"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        wrapClassName="custom-modal"
      >
        <div style={{ padding: '20px 0' }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8 }}>Тайлант хугацаа</div>
            <Select
              value={yearType}
              onChange={(value) => setYearType(value)}
              style={{ width: '100%' }}
              options={Object.entries(year_type).map(([key, value]) => ({
                value: key,
                label: value,
              }))}
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ marginBottom: 8 }}>Файл</div>
            <Select
              value={fileType}
              onChange={(value) => setFileType(value)}
              style={{ width: '100%' }}
              options={fileOptions}
              disabled={!yearType}
            />
          </div>

          <div style={{ textAlign: 'right', marginTop: 24 }}>
            <Button
              type="primary"
              onClick={handleDownload}
              disabled={!yearType || !fileType}
              loading={loading}
            >
              {loading ? 'Татаж байна...' : 'Татах'}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExcelExportModal;
